import { type MetaFunction } from '@vercel/remix';
import { AuthLayout } from '../_auth/layout';

export const meta: MetaFunction = () => {
  return [{ title: 'Forgot Password | Paragonix' }];
};

export default function Route() {
  const { onSubmit, success, error } = AuthLayout.useForgotPasswordFormSubmit();

  return (
    <>
      <AuthLayout.Header>
        <AuthLayout.Title>Forgot your Password?</AuthLayout.Title>
        <AuthLayout.Description>
          Enter your email below to reset your password. Remember your password? <a href="/sign-in">Sign In</a>
        </AuthLayout.Description>
      </AuthLayout.Header>

      <AuthLayout.FormContainer>
        <AuthLayout.ForgotPasswordForm success={success} error={error} onSubmit={onSubmit} />
      </AuthLayout.FormContainer>
    </>
  );
}
